import { RequestService } from "../../../../../common/services/RequestService";
import { CREATE_OFFER } from "../constants";
import { dataAdjustmentOffer } from "./adjustOfferData";

export const createOfferRequest = async (profileId, data, ymaps) => {
  const adjustedData = await dataAdjustmentOffer(data, ymaps);
  const response = await RequestService.post(
    CREATE_OFFER.replace("{profile_id}", profileId),
    adjustedData
  );
  return response && response.data;
};
